(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.archiveMobileRefinementReady === 'true') return;

    var track = section.querySelector('.product-gallery__track');
    var progress = section.querySelector('.product-gallery__progress');
    var progressThumb = section.querySelector('.product-gallery__progress-thumb');
    var thumbnailStrip = section.querySelector('.product-gallery__archive-thumbs');
    var title = section.querySelector('.product-main__title');
    var thumbnails = Array.from(section.querySelectorAll('[data-gallery-thumb]'));
    var originalThumbnailParent = thumbnailStrip ? thumbnailStrip.parentNode : null;
    var originalThumbnailNextSibling = thumbnailStrip ? thumbnailStrip.nextSibling : null;

    if (!track || !progress || !progressThumb) return;
    section.dataset.archiveMobileRefinementReady = 'true';

    function positionThumbnailStrip() {
      if (!thumbnailStrip) return;

      if (window.innerWidth <= 900 && title) {
        if (thumbnailStrip.nextElementSibling !== title) {
          title.insertAdjacentElement('beforebegin', thumbnailStrip);
        }
      } else if (originalThumbnailParent && thumbnailStrip.parentNode !== originalThumbnailParent) {
        if (originalThumbnailNextSibling && originalThumbnailNextSibling.parentNode === originalThumbnailParent) {
          originalThumbnailParent.insertBefore(thumbnailStrip, originalThumbnailNextSibling);
        } else {
          originalThumbnailParent.appendChild(thumbnailStrip);
        }
      }
    }

    function setActive(index) {
      thumbnails.forEach(function (thumbnail, thumbnailIndex) {
        var active = thumbnailIndex === index;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (thumbnailStrip && thumbnails[index]) {
        var target = thumbnails[index];
        var desiredLeft = target.offsetLeft - ((thumbnailStrip.clientWidth - target.offsetWidth) / 2);
        thumbnailStrip.scrollTo({
          left: Math.max(0, desiredLeft),
          behavior: 'smooth'
        });
      }
    }

    function updateGalleryUI() {
      positionThumbnailStrip();
      if (window.innerWidth > 900) return;

      var scrollableWidth = Math.max(0, track.scrollWidth - track.clientWidth);
      var visibleRatio = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
      var thumbWidth = Math.max(24, progress.clientWidth * visibleRatio);
      var availableTravel = Math.max(0, progress.clientWidth - thumbWidth);
      var scrollRatio = scrollableWidth > 0 ? track.scrollLeft / scrollableWidth : 0;

      progressThumb.style.width = thumbWidth + 'px';
      progressThumb.style.transform = 'translate3d(' + (scrollRatio * availableTravel) + 'px,0,0)';

      if (thumbnails.length) {
        var imageWidth = Math.max(1, track.clientWidth);
        var activeIndex = Math.max(0, Math.min(thumbnails.length - 1, Math.round(track.scrollLeft / imageWidth)));
        setActive(activeIndex);
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateGalleryUI();
      });
    }, { passive: true });

    window.addEventListener('resize', updateGalleryUI);
    window.requestAnimationFrame(updateGalleryUI);
  }

  function boot() {
    document.querySelectorAll('.product-main--archive-trial').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
